/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Method_Content_Step_06_Detail_Tournament_0_HeadingInputs */

const en_method_content_step_06_detail_tournament_0_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Tournament_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Axial load attenuation`)
};

const es_method_content_step_06_detail_tournament_0_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Tournament_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Atenuación de la carga axial`)
};

const de_method_content_step_06_detail_tournament_0_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Tournament_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abschwächung der axialen Belastung`)
};

const zh_method_content_step_06_detail_tournament_0_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Tournament_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`减轻轴向负荷`)
};

const ar_method_content_step_06_detail_tournament_0_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Tournament_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تقليل الحمل المحوري`)
};

const fr_method_content_step_06_detail_tournament_0_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Tournament_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Atténuation de la charge axiale`)
};

const vi_method_content_step_06_detail_tournament_0_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Tournament_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suy giảm tải trục`)
};

const sw_method_content_step_06_detail_tournament_0_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Tournament_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kupunguza mzigo kwenye mhimili wa mwili`)
};

const th_method_content_step_06_detail_tournament_0_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Tournament_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`การลดภาระตามแนวแกนกระดูกสันหลัง`)
};

const bs_method_content_step_06_detail_tournament_0_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Tournament_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Atenuacija aksijalnog opterećenja`)
};

const ja_method_content_step_06_detail_tournament_0_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Tournament_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`軸負荷減衰`)
};

const ko_method_content_step_06_detail_tournament_0_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Tournament_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`축 하중 감쇠`)
};

const pt_method_content_step_06_detail_tournament_0_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Tournament_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A atenuação da carga axial`)
};

const it_method_content_step_06_detail_tournament_0_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Tournament_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`attenuazione del carico assiale`)
};

const sv_method_content_step_06_detail_tournament_0_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Tournament_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Axial last dämpning`)
};

const nl_method_content_step_06_detail_tournament_0_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Tournament_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Axiale belastingdemping`)
};

const da_method_content_step_06_detail_tournament_0_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Tournament_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dæmpning af aksial belastning`)
};

const nb_method_content_step_06_detail_tournament_0_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Tournament_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aksial belastning demping`)
};

const fi_method_content_step_06_detail_tournament_0_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Tournament_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aksiaalisen kuormituksen vaimennus`)
};

const pl_method_content_step_06_detail_tournament_0_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Tournament_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tłumienie obciążenia osiowego`)
};

const ru_method_content_step_06_detail_tournament_0_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Tournament_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Осевое затухание нагрузки`)
};

const tr_method_content_step_06_detail_tournament_0_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Tournament_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aksiyel yükün azaltılması`)
};

const hi_method_content_step_06_detail_tournament_0_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Tournament_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अक्षीय भार क्षीणन`)
};

const id_method_content_step_06_detail_tournament_0_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Tournament_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Peredaman beban aksial`)
};

const ms_method_content_step_06_detail_tournament_0_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Tournament_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pengurangan beban paksi`)
};

const cs_method_content_step_06_detail_tournament_0_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Tournament_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Útlum axiálního zatížení`)
};

const el_method_content_step_06_detail_tournament_0_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Tournament_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Εξασθένηση αξονικού φορτίου`)
};

const he_method_content_step_06_detail_tournament_0_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Tournament_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`הנחתת עומס צירי`)
};

const af_method_content_step_06_detail_tournament_0_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Tournament_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aksiale lasdemping`)
};

const hu_method_content_step_06_detail_tournament_0_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Tournament_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A tengelyirányú terhelés csillapítása`)
};

/**
* | output |
* | --- |
* | "Axial load attenuation" |
*
* @param {Method_Content_Step_06_Detail_Tournament_0_HeadingInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const method_content_step_06_detail_tournament_0_heading = /** @type {((inputs?: Method_Content_Step_06_Detail_Tournament_0_HeadingInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Method_Content_Step_06_Detail_Tournament_0_HeadingInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_method_content_step_06_detail_tournament_0_heading(inputs)
	if (locale === "de") return de_method_content_step_06_detail_tournament_0_heading(inputs)
	if (locale === "zh") return zh_method_content_step_06_detail_tournament_0_heading(inputs)
	if (locale === "ar") return ar_method_content_step_06_detail_tournament_0_heading(inputs)
	if (locale === "fr") return fr_method_content_step_06_detail_tournament_0_heading(inputs)
	if (locale === "vi") return vi_method_content_step_06_detail_tournament_0_heading(inputs)
	if (locale === "sw") return sw_method_content_step_06_detail_tournament_0_heading(inputs)
	if (locale === "th") return th_method_content_step_06_detail_tournament_0_heading(inputs)
	if (locale === "bs") return bs_method_content_step_06_detail_tournament_0_heading(inputs)
	if (locale === "ja") return ja_method_content_step_06_detail_tournament_0_heading(inputs)
	if (locale === "ko") return ko_method_content_step_06_detail_tournament_0_heading(inputs)
	if (locale === "pt") return pt_method_content_step_06_detail_tournament_0_heading(inputs)
	if (locale === "it") return it_method_content_step_06_detail_tournament_0_heading(inputs)
	if (locale === "sv") return sv_method_content_step_06_detail_tournament_0_heading(inputs)
	if (locale === "nl") return nl_method_content_step_06_detail_tournament_0_heading(inputs)
	if (locale === "da") return da_method_content_step_06_detail_tournament_0_heading(inputs)
	if (locale === "nb") return nb_method_content_step_06_detail_tournament_0_heading(inputs)
	if (locale === "fi") return fi_method_content_step_06_detail_tournament_0_heading(inputs)
	if (locale === "pl") return pl_method_content_step_06_detail_tournament_0_heading(inputs)
	if (locale === "ru") return ru_method_content_step_06_detail_tournament_0_heading(inputs)
	if (locale === "tr") return tr_method_content_step_06_detail_tournament_0_heading(inputs)
	if (locale === "hi") return hi_method_content_step_06_detail_tournament_0_heading(inputs)
	if (locale === "id") return id_method_content_step_06_detail_tournament_0_heading(inputs)
	if (locale === "ms") return ms_method_content_step_06_detail_tournament_0_heading(inputs)
	if (locale === "cs") return cs_method_content_step_06_detail_tournament_0_heading(inputs)
	if (locale === "el") return el_method_content_step_06_detail_tournament_0_heading(inputs)
	if (locale === "he") return he_method_content_step_06_detail_tournament_0_heading(inputs)
	if (locale === "af") return af_method_content_step_06_detail_tournament_0_heading(inputs)
	if (locale === "hu") return hu_method_content_step_06_detail_tournament_0_heading(inputs)
	return en_method_content_step_06_detail_tournament_0_heading(inputs)
});